import { UseQueryResult } from '@tanstack/react-query';
import { BenefitListDTO } from 'probonio-shared-ui/api';
import { apis, useEmployeeQuery } from 'probonio-shared-ui/module/api';

export function useActiveBenefitsQuery(): UseQueryResult<BenefitListDTO, Error> {
  return useEmployeeQuery(['benefits', apis.benefits.getBenefits.name], params =>
    apis.benefits.getBenefits({ ...params }).then(res => res.data),
  );
}
